var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPipelineIcon = function SvgPipelineIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "pipeline",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "16px",
    height: "16px",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill:#6A6E73;}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "pipelineIcon",
    className: "st0",
    d: "M15,9.3v5h-2.3V13H8.3c-0.8,0-1.4-0.6-1.4-1.4V9H5.5V7.6h1.3V6c0-0.4-0.3-0.7-0.7-0.7H3.3 v1.3H1v-5h2.3V3h4.4c0.8,0,1.4,0.6,1.4,1.4v3.1h1.3V9H9.1v1c0,0.4,0.3,0.7,0.7,0.7h2.9V9.3H15z"
  })));
};
export default SvgPipelineIcon;